<main
    #pageRoot
    class="rayalina-page rayalina-auth-shell rayalina-auth-shell--split contact-page ray-page-enter"
    [class.ray-page-enter--ready]="pageEntered"
>
    <aside class="auth-aside contact-aside" aria-label="Coordonnées Rayalina">
        <div class="contact-aside__intro ray-hero-enter" data-ray-reveal>
            <p class="ray-eyebrow contact-aside__eyebrow">Contact</p>
            <h1 class="auth-aside__title">Parlons de votre boutique, pas d'un formulaire générique.</h1>
            <p class="auth-aside__lead">
                Questions sur l'essai, une formule Entreprise ou un cas particulier à Madagascar :
                décrivez votre contexte, on vous répond avec des réponses concrètes.
            </p>
        </div>

        <div class="contact-aside__channels" data-ray-reveal>
            <h2 class="contact-aside__channels-title">Autres moyens de nous joindre</h2>
            <ul class="contact-channel-list">
                <li *ngFor="let channel of channels">
                    <a
                        [href]="channel.href"
                        class="contact-channel"
                        [attr.target]="channel.external ? '_blank' : null"
                        [attr.rel]="channel.external ? 'noopener noreferrer' : null"
                    >
                        <span class="contact-channel__icon" aria-hidden="true">
                            <i class="bx" [ngClass]="channel.icon"></i>
                        </span>
                        <span class="contact-channel__body">
                            <span class="contact-channel__label">{{ channel.label }}</span>
                            <span class="contact-channel__value">{{ channel.value }}</span>
                        </span>
                        <i class="bx bx-right-arrow-alt contact-channel__arrow" aria-hidden="true"></i>
                    </a>
                </li>
            </ul>
        </div>
    </aside>

    <div class="auth-main">
        <div class="auth-main__inner">
            <div class="auth-card contact-card" data-ray-reveal>
                <header class="auth-card-header">
                    <h2 class="auth-title">Contactez-nous</h2>
                    <p class="auth-sub">
                        Déjà client ?
                        <a routerLink="/auth/login">Connectez-vous</a>
                        pour le support in-app. Sinon, utilisez ce formulaire.
                    </p>
                </header>

                <div class="contact-success" *ngIf="submitted" role="status" aria-live="polite">
                    <span class="contact-success__icon" aria-hidden="true">
                        <i class="bx bx-check-circle"></i>
                    </span>
                    <h3 class="contact-success__title">Message envoyé</h3>
                    <p class="contact-success__text">
                        Merci, nous avons bien reçu votre demande et vous répondrons à l'adresse
                        indiquée dans les plus brefs délais.
                    </p>
                    <div class="contact-success__actions">
                        <button type="button" class="primary-btn" (click)="resetForm()">
                            Nouveau message
                        </button>
                    </div>
                </div>

                <form
                    *ngIf="!submitted"
                    [formGroup]="contactForm"
                    (ngSubmit)="onSubmit()"
                    class="rayalina-auth-form contact-form"
                    novalidate
                >
                    <div class="field">
                        <label for="ray-contact-name">Nom complet</label>
                        <input
                            id="ray-contact-name"
                            type="text"
                            formControlName="name"
                            autocomplete="name"
                        />
                        <span
                            class="field-error"
                            *ngIf="name?.hasError('required') && (name?.touched || formSubmitted)"
                        >
                            Indiquez comment nous pouvons vous appeler.
                        </span>
                    </div>

                    <div class="field">
                        <label for="ray-contact-email">Adresse email</label>
                        <input
                            id="ray-contact-email"
                            type="email"
                            formControlName="email"
                            autocomplete="email"
                        />
                        <span
                            class="field-error"
                            *ngIf="
                                (email?.hasError('required') || email?.hasError('email')) &&
                                (email?.dirty || formSubmitted)
                            "
                        >
                            Entrez une adresse email valide pour la réponse.
                        </span>
                    </div>

                    <div class="field">
                        <label for="ray-contact-phone">Téléphone <span class="field-optional">(facultatif)</span></label>
                        <div class="rayalina-intl-input">
                            <intl-tel-input
                                formControlName="phone"
                                [inputProps]="{ id: 'ray-contact-phone', autocomplete: 'tel' }"
                                [initOptions]="intlTelOptions"
                            ></intl-tel-input>
                        </div>
                    </div>

                    <div class="field">
                        <label for="ray-contact-topic">Sujet</label>
                        <select id="ray-contact-topic" formControlName="topic">
                            <option *ngFor="let option of topics" [value]="option.value">
                                {{ option.label }}
                            </option>
                        </select>
                    </div>

                    <div class="field">
                        <label for="ray-contact-message">Message</label>
                        <textarea
                            id="ray-contact-message"
                            formControlName="message"
                            rows="5"
                            placeholder="Décrivez votre activité, votre volume de commandes ou votre question."
                        ></textarea>
                        <p class="field-hint">Minimum 20 caractères pour nous aider à vous orienter.</p>
                        <span
                            class="field-error"
                            *ngIf="message?.hasError('required') && (message?.touched || formSubmitted)"
                        >
                            Le message est requis.
                        </span>
                        <span
                            class="field-error"
                            *ngIf="message?.hasError('minlength') && (message?.dirty || formSubmitted)"
                        >
                            Ajoutez un peu plus de contexte (au moins 20 caractères).
                        </span>
                    </div>

                    <p class="form-banner-error" *ngIf="submitError">{{ submitError }}</p>

                    <button type="submit" class="submit-btn primary-btn" [disabled]="submitting">
                        {{ submitting ? "Envoi en cours…" : "Envoyer le message" }}
                    </button>
                </form>
            </div>
        </div>
    </div>
</main>
